import React from 'react';
import { Project } from '../types';
import { useUsers } from '../hooks/useUsers';
import { UserTable } from './UserTable';
import { Toaster } from 'react-hot-toast';

interface UsersProps {
  project: Project;
}

export const Users: React.FC<UsersProps> = ({ project }) => {
  const { users, loading, addUser, updateReviewLevel, removeUser, inviteUsers } = useUsers(project.id);

  const handleAddUser = async (email: string, role: 'attempt' | 'review') => {
    await addUser(email, role);
  };

  const handleUpdateReviewLevel = async (userId: string, reviewLevel: number) => {
    await updateReviewLevel(userId, reviewLevel);
  };

  const handleRemoveUser = async (userId: string) => {
    await removeUser(userId);
  };

  return (
    <div className="h-full">
      <UserTable
        users={users}
        projectId={project.id}
        onAddUser={handleAddUser}
        onUpdateReviewLevel={handleUpdateReviewLevel}
        onRemoveUser={handleRemoveUser}
        loading={loading}
        onInviteUsers={inviteUsers}
      />
      <Toaster 
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff',
          },
          success: {
            duration: 3000,
          },
        }}
      />
    </div>
  );
};